import { TemplateName, TemplateVariable } from "./types";
import { EmailTemplate } from "./baseTemplate";
export class DefaultTemplate extends EmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.Default;
    }
    subject({ communication }) {
        return "An Email from Encamp";
    }
    extractVariables({ communication }) {
        return {
            [TemplateVariable.FacilityNames]: communication.facilities
                .map((f) => this.identifierSection(f))
                .join("<br /><br />"),
            [TemplateVariable.CompanyName]: communication.tenant.name,
        };
    }
    rawTemplate() {
        return this.baseText({
            identifierSection: `{{${TemplateVariable.FacilityNames}}}`,
            companyName: `{{${TemplateVariable.CompanyName}}}`,
            isRevision: false,
        });
    }
    text({ communication }) {
        const variables = this.extractVariables({ communication });
        return this.baseText({
            identifierSection: variables[TemplateVariable.FacilityNames],
            companyName: variables[TemplateVariable.CompanyName],
            isRevision: false,
        });
    }
}
//# sourceMappingURL=defaultTemplate.js.map